import { ELanguageCode } from './enums/country.enum';

export function detectLanguageFromUrl(url: string): ELanguageCode | null {
  if (url.startsWith('/en/') || url === '/en') {
    return ELanguageCode.EN;
  }
  return null;
}
